import { render } from "./ContactCoach.vue?vue&type=template&id=494d58f8&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=494d58f8&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494d58f8"]])

export default __exports__